<nz-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [nzDisabled]="isDisabled" [nzMode]="hxMode"
           nzPlaceHolder="Выберите город" [nzDropdownMatchSelectWidth]="false" nzAllowClear nzShowSearch>
  <nz-option-group *ngFor="let opg of optionGroups" [nzLabel]="opg.countryTitle | uiLabel">
    <nz-option *ngFor="let op of opg.options" [nzLabel]="op.title | uiLabel" [nzValue]="op.id"></nz-option>
  </nz-option-group>
</nz-select>
